import { LanguageType } from 'providers/ConnectedIntl/languages'
import * as React from 'react'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'

import configureLocale from './configureLocales'

type PropsType = {
  children: React.ReactNode
  language: LanguageType
}

const mapLocale = (locale) => (locale === 'es-la' ? 'es-419' : locale)

export const ConnectedIntlProvider = ({ children, language }: PropsType) => {
  const [messages, setMessages] = React.useState<Record<string, string> | null>(null)
  React.useEffect(() => {
    configureLocale(language).then(setMessages)
  }, [language])

  if (!messages) return null

  return (
    <IntlProvider locale={mapLocale(language)} messages={messages}>
      {children}
    </IntlProvider>
  )
}

const mapStateToProps = (state) => ({
  language: state.app.language
})

export default connect(mapStateToProps)(ConnectedIntlProvider)
